import React from "react";
import VerticalDivider from "@components/ui/vertical_divider";
import greenhouseLogo from "@images/greenhouse_logo.svg";
import { cn } from "@/lib/utils";
import IdentityVerificationLogo from "@/components/ui/identity_verification_logo";

type Props = {
  className?: string;
  partner?: string | null;
};

const IdentityVerificationModalHeader: React.FC<Props> = ({ className = "", partner }) => (
  <div className={cn("flex items-center justify-center mb-8 w-full", className)}>
    <img src={greenhouseLogo} alt="My Greenhouse Logo" className="h-8 mr-6" />
    <VerticalDivider />
    <IdentityVerificationLogo partner={partner} size="md" className="ml-6" />
  </div>
);

export default IdentityVerificationModalHeader;
